export default __webpack_public_path__ + "static/media/test1.2b466d22.pdf";